import { useEffect, useState } from "react";
import { useAuth } from "../lib/useAuth";
import { api } from "../lib/api";

interface AdminOverview {
  status: string;
}

export function AdminPage() {
  const { user } = useAuth();
  const [overview, setOverview] = useState<AdminOverview | null>(null);
  const [overviewError, setOverviewError] = useState<string | null>(null);

  useEffect(() => {
    api.adminOverview()
      .then(setOverview)
      .catch((err: Error) => setOverviewError(err.message));
  }, []);

  return (
    <div>
      <h1 style={{ margin: "0 0 1.5rem" }}>Admin</h1>

      <div className="card" style={{ marginBottom: "1rem" }}>
        <h2 style={{ marginTop: 0, fontSize: "1.1rem" }}>Platform overview</h2>
        {overviewError ? (
          <p style={{ color: "#ef4444", margin: 0 }}>{overviewError}</p>
        ) : overview ? (
          <p style={{ color: "var(--muted)", margin: 0 }}>
            Status: <strong style={{ color: "var(--text)" }}>{overview.status}</strong>
          </p>
        ) : (
          <p style={{ color: "var(--muted)", margin: 0 }}>Loading…</p>
        )}
      </div>

      <div className="card">
        <h2 style={{ marginTop: 0, fontSize: "1.1rem" }}>Your groups</h2>
        {user && user.groups && user.groups.length > 0 ? (
          <ul style={{ margin: 0, paddingLeft: "1.25rem" }}>
            {user.groups.map((g) => (
              <li key={g} style={{ color: "var(--text)", fontSize: "0.9rem", padding: "0.2rem 0" }}>{g}</li>
            ))}
          </ul>
        ) : (
          <p style={{ color: "var(--muted)", margin: 0 }}>No groups assigned.</p>
        )}
      </div>
    </div>
  );
}
